/**
 * Utility functions for formatting metrics data
 */

/**
 * Format a quarterly version string to a readable format
 * @param version Version string to format
 * @returns Formatted version string for display
 */
export const formatVersionDisplay = (version: string | null): string => {
  if (!version) return '';
  
  // Trim any whitespace
  version = version.trim();
  
  // Check if it's a quarterly version like Q1 2023
  const quarterlyMatch = /q([1-4])\s*(\d{4})/i.exec(version);
  if (quarterlyMatch) {
    const quarter = quarterlyMatch[1];
    const year = quarterlyMatch[2];
    return `Q${quarter} ${year}`;
  }
  
  // Check if it's just a year
  const yearMatch = /^\s*(\d{4})\s*$/.exec(version);
  if (yearMatch) {
    return yearMatch[1];
  }
  
  // Check if it's a date format YYYY-MM-DD
  const dateMatch = /(\d{4})-(\d{2})-(\d{2})/.exec(version);
  if (dateMatch) {
    const year = dateMatch[1];
    const month = dateMatch[2];
    const day = dateMatch[3];
    return `${year}-${month}-${day}`;
  }
  
  // If it's YYYYQX format (e.g., 2023Q2)
  const yyyyQxMatch = /^(\d{4})Q([1-4])$/.exec(version);
  if (yyyyQxMatch) {
    const year = yyyyQxMatch[1];
    const quarter = yyyyQxMatch[2];
    return `Q${quarter} ${year}`;
  }
  
  return version;
};
